"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TaxRule = void 0;
/**
 * Abstract base class for tax rules
 * Equivalent to Java's TaxRule
 */
class TaxRule {
}
exports.TaxRule = TaxRule;
//# sourceMappingURL=TaxRule.js.map